import React from 'react';
import FilterTable from './filterTable';

const WebViewerFeaturePackagesTable = (props) => {
  const columns = [
    {
      dataField: 'id',
      text: 'Id',
      sort: true,
      filter_: { type: 'text' },
    },
    {
      dataField: 'uid',
      text: 'Uid',
      sort: true,
      filter_: { type: 'text' },
    },
    {
      dataField: 'name',
      text: 'Name',
      sort: true,
      filter_: { type: 'text' },
    },
    {
      dataField: 'permissions',
      text: 'Permissions',
      sort: true,
      filter_: { type: 'text' },
    }, {
      dataField: 'isDeprecated',
      text: 'Deprecated',
      sort: false,
      filter_: {
        type: 'select',
        values: {
          'all': '',
          'true': 'true',
          'false': 'false'
        }
      }
    }
  ];

  const defaultSorted = [
    {
      dataField: 'id',
      order: 'asc',
    },
  ];

  return (
    <FilterTable
      {...props}
      objectName={'webViewerFeaturePackages'}
      data={props.webViewerFeaturePackages}
      columns={columns}
      noDataIndication="There are no web viewer feature packages"
      defaultSorted={defaultSorted}
    />
  );
}

export default WebViewerFeaturePackagesTable;


// WEBPACK FOOTER //
// ./src/components/webViewerFeaturePackagesTable.js